import { ResponsiveSheet } from "@wags/ui/responsive-sheet.tsx";
import { BandTextButton } from "./provider-band-text-button";
import {
    type PolicyView,
    previewClamp,
    shouldOfferPolicySheet,
} from "./provider-policies";
import { PolicyFull, PolicyPreview } from "./provider-policy-text";

function PoliciesSheet({ policies }: { policies: PolicyView[] }) {
    const isSingle = policies.length === 1;
    return (
        <ResponsiveSheet
            title={isSingle ? (policies[0]?.label ?? "Policies") : "Policies"}
            trigger={
                <BandTextButton>
                    {isSingle ? "See full policy" : "See all policies"}
                </BandTextButton>
            }
        >
            <div className="divide-y divide-doberman-black/10">
                {policies.map((policy) => (
                    <section
                        key={policy.id}
                        className="py-5 first:pt-0 last:pb-0"
                    >
                        {!isSingle && (
                            <h3 className="mb-2 text-body font-semibold text-doberman-black">
                                {policy.label}
                            </h3>
                        )}
                        <PolicyFull policy={policy} />
                    </section>
                ))}
            </div>
        </ResponsiveSheet>
    );
}

export function PoliciesColumn({ policies }: { policies: PolicyView[] }) {
    const clamp = previewClamp(policies.length);
    return (
        <>
            <div className="max-w-prose space-y-6">
                {policies.map((policy) => (
                    <div key={policy.id}>
                        <h3 className="text-body-small font-medium text-doberman-black/55">
                            {policy.label}
                        </h3>
                        <PolicyPreview
                            policy={policy}
                            clampClassName={clamp.className}
                        />
                    </div>
                ))}
            </div>
            {shouldOfferPolicySheet(policies) && (
                <PoliciesSheet policies={policies} />
            )}
        </>
    );
}
